export default "__VITE_ASSET__DLvk8oDu__"